<template lang="pug">
Teleport(v-if="titleEl", :to="titleEl")
	slot(name="title")
		span {{ title }}
div.tab-pane(
	role="tabpanel",
	:class="{ active: isActive, show: isActive }",
	v-show="isActive"
)
	slot(v-if="shouldRender")
</template>

<script>
let tabUid = 0;

export default {
	name: "BTab",
	inject: {
		btabs: { default: null },
	},
	props: {
		title: String,
		active: Boolean,
		disabled: Boolean,
		/** When true, slot mounts only after the tab is first activated. */
		lazy: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			uid: ++tabUid,
			visited: false,
			titleEl: null,
		};
	},
	computed: {
		isActive() {
			return this.btabs?.activeUid === this.uid;
		},
		shouldRender() {
			if (!this.lazy) {
				return true;
			}
			return this.visited || this.isActive;
		},
	},
	watch: {
		// Keep parent nav entry in sync — register() only snapshots once
		disabled(val) {
			this.btabs?.setDisabled(this.uid, !!val);
		},
		isActive: {
			immediate: true,
			handler(active) {
				if (active) {
					this.visited = true;
				}
			},
		},
	},
	mounted() {
		this.btabs?.register(this);
	},
	beforeUnmount() {
		this.titleEl = null;
		this.btabs?.unregister(this.uid);
	},
	methods: {
		setTitleMount(el) {
			this.titleEl = el || null;
		},
	},
};
</script>
